<template>
  <div class="residential-account-unit">
    <div class="residential-account-unit__cover-wrapper content">
      <Slider
        class="residential-account-unit__cover"
        v-if="media && media.length"
        :value="media"
        :display-thumbnail="true"
      />
    </div>
    <Card class="residential-account-unit__content">
      <Summary :value="reference">
        <template #actions>
          <slot name="actions" />
        </template>
      </Summary>
      <Properties :value="reference" />
    </Card>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import Slider from '@kvass/media-render/Slider'
import Card from '@/components/Card'
import Properties from './Properties'
import Summary from './Summary'

export default {
  computed: {
    ...mapState('ResidentialAccount', {
      item: 'item',
      reference: state => state.item.reference,
    }),
    media() {
      return (this.$path('media.cover', this.reference) || []).concat(this.$path('media.gallery', this.reference) || [])
    },
  },
  components: {
    Slider,
    Card,
    Properties,
    Summary,
  },
}
</script>

<style lang="scss">
.residential-account-unit {
  .card__content {
    padding: 2rem;
  }
  &__cover {
    background-color: css-alpha('primary', 0.07);

    &-wrapper {
      height: 45vh;
      width: 100%;
    }
  }

  &__content {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.9) 0%, white 60%);
    backdrop-filter: blur(5px);
  }
}
</style>
